module.exports = __webpack_public_path__ + "img/20.c8a2d966.jpg";